<!-- 濮阳市运行监控 -->
<template>
    <div class='pagebg box box_v'>
        <!-- 页面标题 -->
        <div class="box box_between">
            <div class="title_top">{{date}}</div>
            <div class="title_center_bg">
                <div class="title_center">濮阳市便民服务监测</div>
            </div>
            <div class="box">
                <div class="title_top">{{weather}}</div>
                <img :src="weatherPic" class="weatherPic"/>
            </div>

        </div>
        <!-- tab切换 -->
        <div class="tab_wrapper box">
            <div 
             v-for="(item,index) in tablist" :key="index"
            :class="index==selectIndex?'tabitem active':'tabitem'"
            @click="clickTab(index)"
            >
                {{index!=1 ? item.label : selectIndex!=1 ? item.label : ''}}
                <div v-if="index==1 && selectIndex==1" class="btn_wrapper">
                    <el-dropdown @command="handleCommand" class="el_dropdown">
                        <el-button type="primary" class="el_button">
                            {{btnList[btnListIndex].cityName}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown" class="el_dropdown_menu">
                            <el-dropdown-item v-for="(items,index) in btnList" :key="index" :command="index">{{items.cityName}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            
        </div>
        <!-- 页面内容 -->
        <div class="box box_f1" style="position: relative;">
            <div ref='carousel_wrapper_div' class="carousel_wrapper_div">
                <Carousel v-model="selectIndex" class="carousel_wrapper" id="carousel">
                    <CarouselItem>
                        <!--概况-->
                        <overview :style="{height:carousel_height}" :show="selectIndex==0?true:false"></overview>
                    </CarouselItem>
                    <CarouselItem>
                        <!--不动产-->
                        <estate :style="{height:carousel_height}" :show="selectIndex==1?true:false" :communityId="communityIds"></estate>
                    </CarouselItem>
                    <CarouselItem>
                        <!--首席服务员-->
                        <cheif :style="{height:carousel_height}" :show="selectIndex==2?true:false"></cheif>
                    </CarouselItem>
                    <CarouselItem>
                        <!--我向市长说句话-->
                        <event :style="{height:carousel_height}" :show="selectIndex==3?true:false"></event>
                    </CarouselItem>
                   <!-- 新生入学 -->
                   <!-- <CarouselItem>
                      <students :style="{height:carousel_height}" :show="selectIndex==4?true:false"></students>
                    </CarouselItem> -->
                    <!--养老服务-->
                    <!-- <CarouselItem>

                        <shebao :style="{height:carousel_height}" :show="selectIndex==5?true:false"></shebao>
                    </CarouselItem> -->

                </Carousel>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import axios from "axios";
import echarts from 'echarts'
import overview from "./components/overview/index"
import estate from "./components/estate/index"
import cheif from "./components/cheif/index"
import event from "./components/event/index"
import shebao from './components/shebao/index'
import students from './components/students/index'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {overview,estate,cheif,event,shebao,students},
    data() {
    //这里存放数据
        return {
            date:'',
            tablist:[{
                selected:true,
                label:'概况',
                selected:true
            },{
                selected:false,
                label:'不动产登记'
            },{
                selected:false,
                label:'首席服务员'
            }
            ,{
                selected:false,
                label:'我向市长说句话'
            },
            // {
            //     selected:false,
            //     label:'新生入学'
            // },
            // ,{
            //     selected:false,
            //     label:'养老服务'
            // }
            ],
            weather:'',
            weatherPic:'',
            selectIndex:0,
            communityIds:1,
            btnList:[
                {
                    cityName:'全部',
                    communityId:1
                },
                {
                    cityName:'濮阳市',
                    communityId:410900000000
                },
                {
                    cityName:'南乐县',
                    communityId:410923000000
                },
                {
                    cityName:'濮阳县',
                    communityId:410928000000
                },
                {
                    cityName:'清丰县',
                    communityId:410922000000
                },
                {
                    cityName:'范县',
                    communityId:410926000000
                },
                {
                    cityName:'台前县',
                    communityId:410927000000
                }
            ],
            btnListIndex:0,
            carousel_height:'800px',
            timer:null
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        handleCommand(e){
            this.btnListIndex = e
            this.communityIds = this.btnList[this.btnListIndex].communityId
        },
        clickTab(index){
            this.selectIndex = index
        },
        getWeather(){
            axios({
                url:this.urlobj.getWeather+'?area=濮阳',
                headers:{
                    Authorization: "APPCODE b0ca862be8e8409a91d735179f4d07ed"
                },
                method:'get',

            }).then(res=>{
                 console.log('success',res)
                 res = res.data
                    let data = res.showapi_res_body.now
                    this.weather = '空气质量'+data.aqiDetail.quality+'  '+data.weather+'  '+data.temperature+'℃'
                    this.weatherPic = data.weather_pic
            })
        },
        setDates(){
            this.timer = setInterval(()=>{
                this.date = this.$util.FormatDate(new Date(),"yyyy年MM月dd日  HH:mm:ss") + "  星期" + this.$util.number2Chinese(new Date().getDay())
            },1000)
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.communityIds = this.btnList[this.btnListIndex].communityId
        this.setDates()
        this.getWeather()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(()=>{
            this.carousel_height = this.$refs['carousel_wrapper_div'].clientHeight + 'px'
        })
         window.onresize = ()=> {
            let clientHeight = this.$refs['carousel_wrapper_div'].clientHeight
            this.carousel_height = clientHeight+'px';
        };
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {
        clearInterval(this.timer)
    }, //生命周期 - 销毁之前
    destroyed() {
        window.onresize = null
    }, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.pagebg{
    width: 100%;
    height: 100%;
    background-image: url('../../assets/images/monitorpy/bg.jpg');
    background-size: 100% 100%;
    padding:20px
}
.weatherPic{
    display: flex;
    width: 40px;
    height: 40px;
    margin-top: 18px;
    margin-left: 10px;
}
.title_top{
    margin-top: 18px;
    font-size: 20px;
    color: #0EBFFF;
    line-height: 45px;
    white-space:pre
}
.title_center_bg{
    position:fixed;
    top: 20px;
    left: 292px;
    right:292px;
    height:50px;
    background-image: url('../../assets/images/monitorpy/logo.png');
    background-size: 100% 100%;
    background-repeat: no-repeat
}
.title_center{
    width:100%;
    text-align: center;
    font-weight: bold;
    font-size: 26px;
    color: #FFFFFF;
    line-height: 45px;

    background: linear-gradient(0deg, #BBBBBB 0%, #FFFFFF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.tab_wrapper{
    justify-content: center;
    margin: 10px 0;
    .tabitem{
        width:165px;
        height:50px;
        background-image: url('../../assets/images/monitorpy/tab.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        text-align: center;
        color: #0EBFFF;
        line-height: 50px;
        margin:0 20px;
        position: relative;
    }
    .active{
        color:#fff;
        font-weight: bold;
        .btn_wrapper{
            position: absolute;
            z-index: 999;
            width: 100%;
            display: flex;
            justify-content: center;
            .el_dropdown,
            .el_button{
                width: 100%;
                .el-button--primary{
                    background-color: transparent !important;
                    border-color: transparent !important;
                }
            }
        }
    }
    .active::after{
        content:'';
        position:absolute;
        top:-10px;
        left:38px;
        width:89px;
        height:70px;

        background-image: url('../../assets/images/monitorpy/mouseover.png');
    }
}

.carousel_wrapper_div {
    position: absolute;
    left: 0;
    top: 0;
    width:100%;
    height:100%;
}
.carousel_wrapper{
    position: relative;
    width:100%;
    height:100%;
}
.el_dropdown_menu{
    width: 165px !important;
    background-color: #0b76e1c3 !important;
    border: 1px solid #0EBFFF;
    .el-dropdown-menu__item{
        color: #ffffff !important;
        text-align: center;
        &:hover{
            background-color: rgba(8, 55, 108, 0.911) !important;
            color: #eeeeee !important;
        }
    }

}


</style>
<style>
.el-popper[x-placement^=bottom] .popper__arrow{
    border-bottom-color: transparent !important;
}
.el-popper[x-placement^=bottom] .popper__arrow::after{
    border-bottom-color: #0EBFFF !important;
}</style>